/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const getFirstElements = (array, count = 5) => {
  // handle null
  if (array == null) {
    return [];
  }

  // return slice based on size
  if (array.length <= count) {
    return array;
  } else {
    return array.slice(0, count);
  }
};

export const getLastElements = (array, count = 5) => {
  // handle null
  if (array == null) {
    return [];
  }

  // return slice based on size
  const length = array.length;
  if (length <= count) {
    return array;
  } else {
    return array.slice(length - count);
  }
};

export const moveToFront = (array, callback) => {
  // validate input
  if (!array || !Array.isArray(array)) {
    return [];
  }

  if (!callback) {
    return array;
  }

  // iterate through object
  const index = array.findIndex(callback);
  if (index === -1) {
    return array;
  }

  // move index to front
  const newArray = [
    array[index],
    ...array.slice(0, index),
    ...array.slice(index + 1)
  ];
  return newArray;
};

export const splitIntoSegments = (array, segmentSize) => {
  // validate input
  if (!array || !segmentSize) {
    return array ?? [];
  }

  // split slices of input into un-flattened output
  const result = [];
  for (let i = 0; i < array.length; i += segmentSize) {
    const segment = array.slice(i, i + segmentSize);
    result.push(segment);
  }
  return result;
};
